import { GetTeamRaidWishesResponse } from "@/api/teams/get-team-raid-wishes.response";

export const wishesColors = {
	default: "lightgray"
};

export const wishesColorFunction = (wishValue: GetTeamRaidWishesResponse.Wish[] | null) => {
	if (wishValue == null) {
		return wishesColors.default;
	}
	const max = wishValue.reduce((acc: number, curr: GetTeamRaidWishesResponse.Wish) => Math.max(acc, curr.value), 0);

	if (max == 30) {
		return "#8BC34A";
	}
	else if (max >= 20) {
		return "#FFEB3B";
	}
	else if (max > 0) {
		return "#FF9800";
	}
	else {
		return "#F44336";
	}
};